var _path, _rect, _g, _path2, _rect2, _g2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeightDifference(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00671 6.14839L6.00671 4.18308L6.00671 2.21777",
    stroke: "white",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3888_10886",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 10,
    height: 4
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.24777,
    height: 8.42255,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 10.0576 4.4209)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3888_10886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.68886 5.70754L6.00671 2.02539L2.32456 5.70754",
    stroke: "white",
    strokeWidth: 0.7
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00708 5.1599L6.00708 7.36218L6.00708 9.56445",
    stroke: "white",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3888_10886",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 7,
    width: 10,
    height: 4
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.24777,
    height: 8.42255,
    transform: "matrix(-1.19249e-08 1 1 1.19249e-08 1.95615 7.36133)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3888_10886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.32494 6.07518L6.00708 9.75732L9.68923 6.07518",
    stroke: "white",
    strokeWidth: 0.7
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5011 0.361328L0.454628 0.361328",
    stroke: "white",
    strokeWidth: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5011 11.4106L0.454628 11.4106",
    stroke: "white",
    strokeWidth: 0.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeightDifference);
export default __webpack_public_path__ + "static/media/height-difference.528c45dd483f3921258441b360f6c62a.svg";
export { ForwardRef as ReactComponent };